/**
 * @see mockMd/union_city_war_level_reward_claim.md
 */
import {UnionCityWarActionStatus, type UnionCityWarLevelRewardClaimData} from '../types'

export const UnionCityWarLevelRewardClaimMock: UnionCityWarLevelRewardClaimData = {
  status: UnionCityWarActionStatus.Success,
  err_msg: '',
}
